import React, { forwardRef, useState, useRef, useEffect } from 'react'
import './FileUploader.scss'

const buttonStyles = 'label-as-button syn-button-success'
const FileUploader = forwardRef((props, theRef) => {
  const { id, name, buttonText, onFilesAdded } = props
  const [fileName, setFileName] = useState()
  const canceled = useRef(false)
  useEffect(() => {
    return () => {
      canceled.current = true
    }
  }, [])
  const handleIt = async e => {
    const temp = { ...e }
    if (!canceled.current) {
      await onFilesAdded(temp.target.files)
      setFileName(temp.target.files[0].name)
    }
  }

  return (
    <div data-testid="fileUploader" className="df aic">
      <input
        className="inputfile"
        id={id}
        name={name}
        ref={theRef}
        type="file"
        onChange={handleIt}
      />
      <div className="flx1 bgc-white bd2-s-input bdrs-4 h42 df aic jcsb pl10 pt10 pb10 pr15 mr10 oh">
        {fileName}
      </div>
      <label
        role="button"
        aria-label="choose-file"
        className={`${buttonStyles} df aic`}
        htmlFor={id}
      >
        {buttonText}
      </label>
    </div>
  )
})

export default FileUploader
